import React__default, { useEffect } from 'react';
import { SubTitle } from '../../Typography/index.es.js';
import { CloseOutlined, SuccessColored, InforOutlined, DeleteCircleColored } from '@teko/ds-icon';
import styled from '@emotion/styled';

const toastIcon = {
  success: /* @__PURE__ */ React__default.createElement(SuccessColored, {
    size: 30
  }),
  info: /* @__PURE__ */ React__default.createElement(InforOutlined, {
    size: 30
  }),
  warning: /* @__PURE__ */ React__default.createElement(InforOutlined, {
    size: 30
  }),
  error: /* @__PURE__ */ React__default.createElement(DeleteCircleColored, {
    size: 30
  })
};
const Toast = ({
  type,
  title,
  message,
  onClose,
  duration = 5e3,
  closeable = true,
  icon,
  onClick
}) => {
  useEffect(() => {
    let handle;
    if (duration) {
      handle = setTimeout(() => onClose == null ? void 0 : onClose(), duration);
    }
    return () => {
      if (handle) {
        clearTimeout(handle);
      }
    };
  }, []);
  return /* @__PURE__ */ React__default.createElement(StyledToast, null, closeable && /* @__PURE__ */ React__default.createElement(CloseOutlined, {
    className: "teko-toast-close",
    size: 24,
    color: "#000000",
    onClick: onClose
  }), /* @__PURE__ */ React__default.createElement("div", {
    className: "teko-toast-content",
    onClick,
    style: {
      cursor: onClick ? "pointer" : "default"
    }
  }, (icon || type) && /* @__PURE__ */ React__default.createElement("div", {
    className: "teko-toast-icon"
  }, icon ? icon : type && toastIcon[type]), /* @__PURE__ */ React__default.createElement("div", null, title && /* @__PURE__ */ React__default.createElement("div", {
    className: "teko-toast-header"
  }, typeof title === "string" ? /* @__PURE__ */ React__default.createElement(SubTitle, {
    level: 2,
    className: "teko-toast-title"
  }, title) : /* @__PURE__ */ React__default.createElement("div", {
    className: "teko-toast-title"
  }, title)), /* @__PURE__ */ React__default.createElement("div", {
    className: "teko-toast-message"
  }, message))));
};
const StyledToast = styled.div`
  width: 384px;
  max-width: calc(100vw - 24px * 2);
  position: relative;
  .teko-toast-icon {
    margin-right: 20px;
  }
  .teko-toast-close {
    position: absolute;
    z-index: 1000;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }
  .teko-toast-content {
    position: relative;
    display: flex;
    padding: 16px 24px;
    border-radius: 8px;
    box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%),
      0 9px 28px 8px rgb(0 0 0 / 5%);
    background: white;
    & .teko-toast-header {
      margin-right: 16px;
    }
  }
`;

export { Toast };
